import { render, staticRenderFns } from "./EscrowAccount.vue?vue&type=template&id=836de93a&scoped=true&"
import script from "./EscrowAccount.vue?vue&type=script&lang=js&"
export * from "./EscrowAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836de93a",
  null
  
)

export default component.exports